module.exports = __webpack_public_path__ + "static/media/skeleton.2e8c4e84.svg";